import buildQueryString from '../../helpers/query-builder'

$.onmount('[data-component="charts/select-month"]', function() {
  var $el = $(this)

  $el.selectize({
    highlight: false,
    valueField: 'value',
    labelField: 'id',
    searchField: ['id'],
    options: [],
    create: false,
    preload: 'focus',
    onItemAdd: function(val) {
      const query =  buildQueryString({ month: val } )
      window.location = `${window.location.pathname}?${query}`
    }
  })
})
